import { GridColDef } from '@microservices/wiskey-react-table-component'
import { Variable } from '@mobileTypes'

export const MOBILE_GLOBAL_VARIABLES_COLUMNS: GridColDef[] = [
  {
    field: 'internalId',
    headerName: 'Internal ID',
    flex: 1,
    minWidth: 200,
  },
  {
    field: 'variableType',
    headerName: 'Variable Type',
    flex: 1,
    minWidth: 120,
  },
  {
    field: 'valueType',
    headerName: 'Value Type',
    flex: 1,
    minWidth: 120,
  },
  {
    field: 'objectCode',
    headerName: 'Object Code',
    flex: 1,
    minWidth: 150,
  },
]

export const STORAGE_KEY_MOBILE_GLOBAL_VARIABLES = 'mobile_global_variables'

export { STORAGE_KEY_MOBILE_GLOBAL_VARIABLES as MOBILE_GLOBAL_VARIABLES_STORAGE_KEY }

